import { ContentType } from "../../../../enums/contentStack.js";
import { getConfigurationSettingByDeveloperKey } from "../../../../services/content/business.lib.js";
import { getConfigurationSettingByDevelopmentKey, ConfigContentType, getClientConfigurationSettings, getConfigurationSettingByConfigKey } from "../../../../services/content/config.lib.js";
import { isBD } from "../../../../utils/businessType.lib.js";
import { getFeatureFlagState } from "../../../../utils/featureFlag.js";
const getProductApiConfig = async () => {
  try {
    return await getConfigurationSettingByDevelopmentKey(
      ConfigContentType.ServiceConfiguration,
      `product_api_service_configuration`
    );
  } catch (err) {
    console.error(
      "ProductApi config - content stack fetch failed",
      err
    );
    return null;
  }
};
const getBModPDPNavigationUrlFeatureToggleConfig = async () => {
  return await getFeatureFlagState(
    "enable_bmod_product_page_navigation_url",
    process.env.APPNAME
  );
};
const getShowMultiVariantsAvailabilityFeatureToggle = async () => {
  return await getFeatureFlagState(
    "enable_multi_variant_availability_message",
    process.env.APPNAME
  );
};
const getInventoryApiConfig = async () => {
  try {
    return await getConfigurationSettingByDevelopmentKey(
      ConfigContentType.ServiceConfiguration,
      `inventory_api_service_configuration`
    );
  } catch (err) {
    console.error(
      "InventoryApi config - content stack fetch failed",
      err
    );
    return null;
  }
};
const getImageConfig = async () => {
  try {
    return await getClientConfigurationSettings();
  } catch (err) {
    console.error("ImageConfig - content stack fetch failed", err);
    return null;
  }
};
const getPillBadgeConfig = async () => {
  try {
    return await getConfigurationSettingByConfigKey(
      ConfigContentType.ConfigurationSetting,
      "forge.pills"
    );
  } catch (err) {
    console.error("PillBadge config - content stack fetch failed", err);
    return null;
  }
};
const getProductSummaryAPIFeatureToggle = async () => {
  return await getFeatureFlagState(
    "enable_product_summary_api",
    process.env.APPNAME
  );
};
const getComingSoonFeatureToggleConfig = async () => {
  try {
    return await getConfigurationSettingByDevelopmentKey(
      ConfigContentType.FeatureToggle,
      "enable_coming_soon_banner"
    );
  } catch (err) {
    console.error(
      "Coming soon featureToggle config - content stack fetch failed",
      err
    );
    return null;
  }
};
const getStockStatusFeatureToggleConfig = async () => {
  try {
    return await getConfigurationSettingByDevelopmentKey(
      ConfigContentType.FeatureToggle,
      "enable_stock_status"
    );
  } catch (err) {
    console.error(
      "Enable stock featureToggle config - content stack fetch failed",
      err
    );
    return null;
  }
};
const getBOPIUpdatesSyncFeatureToggle = async () => {
  try {
    return await getConfigurationSettingByDevelopmentKey(
      ConfigContentType.FeatureToggle,
      "enable_bopiw_updates_sync"
    );
  } catch (err) {
    console.error(
      "Enable bopiw featureToggle config - content stack fetch failed",
      err
    );
    return null;
  }
};
const getFreightSavingsFeatureToggle = async () => {
  try {
    return await getConfigurationSettingByDevelopmentKey(
      ConfigContentType.FeatureToggle,
      "enable_freight_savings"
    );
  } catch (err) {
    console.error(
      "Enable Freigth Savings featureToggle config - content stack fetch failed",
      err
    );
    return null;
  }
};
const getPromoBreakdownFeatureToggle = async () => {
  try {
    return await getConfigurationSettingByDevelopmentKey(
      ConfigContentType.FeatureToggle,
      "promo_breakdown_ca_compliance"
    );
  } catch (err) {
    console.error(
      "Enable CA Promo Breakdown featureToggle config - content stack fetch failed",
      err
    );
    return null;
  }
};
const getWarehousePriceOnlineFeatureToggleConfig = async () => {
  try {
    return await getFeatureFlagState(
      "warehouse_price_online",
      process.env.APPNAME
    );
  } catch (err) {
    console.error(
      "Enable warehouse price online featureToggle config - content stack fetch failed",
      err
    );
    return null;
  }
};
const getEnabledWarehousesConfig = async () => {
  try {
    return await getConfigurationSettingByConfigKey(
      ConfigContentType.ConfigurationSetting,
      "enabled_warehouses_list"
    );
  } catch (err) {
    console.error(
      "EnabledWarehouses config - content stack fetch failed",
      err
    );
    return null;
  }
};
const getEnabledWarehousesWIOConfig = async () => {
  try {
    return await getConfigurationSettingByConfigKey(
      ConfigContentType.ConfigurationSetting,
      "enabled_warehouses_list_wio"
    );
  } catch (err) {
    console.error(
      "EnabledWarehouses WIO config - content stack fetch failed",
      err
    );
    return null;
  }
};
const getEnabledWarehousesBOPIWConfig = async () => {
  try {
    return await getConfigurationSettingByConfigKey(
      ConfigContentType.ConfigurationSetting,
      "enabled_warehouses_list_bopiw"
    );
  } catch (err) {
    console.error(
      "EnabledWarehouses BOPIW config - content stack fetch failed",
      err
    );
    return null;
  }
};
const getSearchConfig = async () => {
  try {
    return await getConfigurationSettingByConfigKey(
      ConfigContentType.ConfigurationSetting,
      "search_config"
    );
  } catch (err) {
    console.error("Search config - content stack fetch failed", err);
    return null;
  }
};
const getTranslations = async (locale) => {
  try {
    return await getConfigurationSettingByDeveloperKey(
      ContentType.ModuleSettings,
      "product_tile",
      locale
    );
  } catch (err) {
    console.error(
      "ProductTile translations config - content stack fetch failed",
      err
    );
    return null;
  }
};
const getTranslationsConfig = (translationsEntry) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
  const translationObj = {
    featureControls: (_b = (_a = translationsEntry == null ? void 0 : translationsEntry.properties) == null ? void 0 : _a[0]) == null ? void 0 : _b.featureControls,
    groceryBadgeControls: (_d = (_c = translationsEntry == null ? void 0 : translationsEntry.properties) == null ? void 0 : _c[0]) == null ? void 0 : _d.groceryBadgeControls,
    icons: (_f = (_e = translationsEntry == null ? void 0 : translationsEntry.properties) == null ? void 0 : _e[0]) == null ? void 0 : _f.icons,
    keys: (_h = (_g = translationsEntry == null ? void 0 : translationsEntry.properties) == null ? void 0 : _g[0]) == null ? void 0 : _h.keys,
    locale: translationsEntry == null ? void 0 : translationsEntry.locale,
    swatchControls: (_j = (_i = translationsEntry == null ? void 0 : translationsEntry.properties) == null ? void 0 : _i[0]) == null ? void 0 : _j.swatchControls,
    translations: {},
    urls: (_l = (_k = translationsEntry == null ? void 0 : translationsEntry.properties) == null ? void 0 : _k[0]) == null ? void 0 : _l.urls,
    product_display_style: (_n = (_m = translationsEntry == null ? void 0 : translationsEntry.properties) == null ? void 0 : _m[0]) == null ? void 0 : _n.product_display_style,
    tobaccoInState: (_p = (_o = translationsEntry == null ? void 0 : translationsEntry.properties) == null ? void 0 : _o[0]) == null ? void 0 : _p.tobaccoInState,
    promoBreakdownCAProvince: (_r = (_q = translationsEntry == null ? void 0 : translationsEntry.properties) == null ? void 0 : _q[0]) == null ? void 0 : _r.promoBreakdownCAProvince,
    sponsoredProductDisplayStyle: (_t = (_s = translationsEntry == null ? void 0 : translationsEntry.properties) == null ? void 0 : _s[0]) == null ? void 0 : _t.sponsoredProductDisplayStyle
  };
  translationsEntry == null ? void 0 : translationsEntry.key_value.forEach(({ key, value }) => {
    translationObj.translations[key] = value;
  });
  return translationObj;
};
const getParsedProductApiConfig = (productApiConfigEntry, productApiClientId, warehouseNumber) => {
  var _a, _b, _c, _d, _e;
  return {
    apiUrl: productApiConfigEntry == null ? void 0 : productApiConfigEntry.endpoint,
    clientId: (_a = productApiConfigEntry == null ? void 0 : productApiConfigEntry.required_request_parameters.client_identifier) == null ? void 0 : _a[productApiClientId],
    env: (_c = (_b = productApiConfigEntry == null ? void 0 : productApiConfigEntry.required_request_headers) == null ? void 0 : _b.costco) == null ? void 0 : _c.env,
    locale: productApiConfigEntry == null ? void 0 : productApiConfigEntry.locale,
    service: (_e = (_d = productApiConfigEntry == null ? void 0 : productApiConfigEntry.required_request_headers) == null ? void 0 : _d.costco) == null ? void 0 : _e.service,
    warehouseNumber,
    custom_properties: productApiConfigEntry == null ? void 0 : productApiConfigEntry.custom_properties
  };
};
const getParsedPillBadgeConfig = (searchConfigEntry, pillBadgeConfigEntry, pillBadgeLangKey) => {
  var _a, _b, _c, _d, _e;
  return {
    catalogSearchUrl: (_b = (_a = searchConfigEntry == null ? void 0 : searchConfigEntry.custom) == null ? void 0 : _a.searchConfig) == null ? void 0 : _b.searchURL,
    colorMap: (_d = (_c = pillBadgeConfigEntry == null ? void 0 : pillBadgeConfigEntry.custom) == null ? void 0 : _c.colors) == null ? void 0 : _d[pillBadgeLangKey],
    defaultColor: (_e = pillBadgeConfigEntry == null ? void 0 : pillBadgeConfigEntry.custom) == null ? void 0 : _e.color_default
  };
};
const getParsedInventoryApiConfig = (inventoryApiConfigEntry) => {
  var _a, _b, _c, _d, _e, _f;
  return {
    apiUrl: inventoryApiConfigEntry == null ? void 0 : inventoryApiConfigEntry.endpoint,
    clientId: (_a = inventoryApiConfigEntry == null ? void 0 : inventoryApiConfigEntry.required_request_headers) == null ? void 0 : _a.client_identifier,
    env: (_c = (_b = inventoryApiConfigEntry == null ? void 0 : inventoryApiConfigEntry.required_request_headers) == null ? void 0 : _b.costco) == null ? void 0 : _c.env,
    locale: inventoryApiConfigEntry == null ? void 0 : inventoryApiConfigEntry.locale,
    service: (_e = (_d = inventoryApiConfigEntry == null ? void 0 : inventoryApiConfigEntry.required_request_headers) == null ? void 0 : _d.costco) == null ? void 0 : _e.service,
    requestItemCount: (_f = inventoryApiConfigEntry == null ? void 0 : inventoryApiConfigEntry.custom_properties) == null ? void 0 : _f.requestItemCount
  };
};
const getParsedLucidWorksApiConfig = (lucidWorksApiConfig) => {
  var _a, _b, _c;
  return {
    apiUrl: lucidWorksApiConfig == null ? void 0 : lucidWorksApiConfig.endpoint,
    xApiKey: (_a = lucidWorksApiConfig == null ? void 0 : lucidWorksApiConfig.required_request_headers) == null ? void 0 : _a["x-api-key"],
    locale: lucidWorksApiConfig == null ? void 0 : lucidWorksApiConfig.locale,
    defaultBDWarehouse: (_b = lucidWorksApiConfig == null ? void 0 : lucidWorksApiConfig.custom_properties) == null ? void 0 : _b.defaultBDWarehouse,
    additionalURLParams: (_c = lucidWorksApiConfig == null ? void 0 : lucidWorksApiConfig.custom_properties) == null ? void 0 : _c.additionalURLParams,
    timeout: lucidWorksApiConfig == null ? void 0 : lucidWorksApiConfig.timeout,
    connection_timeout: lucidWorksApiConfig == null ? void 0 : lucidWorksApiConfig.connection_timeout
  };
};
const getParsedImageConfig = (imageConfigEntry, siteDomainKey, imageProfileIdKey, imageBasePathKey) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  return {
    domainUrl: (_c = (_b = (_a = imageConfigEntry == null ? void 0 : imageConfigEntry.custom) == null ? void 0 : _a.envConfig) == null ? void 0 : _b.domain) == null ? void 0 : _c[siteDomainKey],
    imageBasePath: (_f = (_e = (_d = imageConfigEntry == null ? void 0 : imageConfigEntry.custom) == null ? void 0 : _d.envConfig) == null ? void 0 : _e.imageBasePath) == null ? void 0 : _f[imageBasePathKey],
    imageServerPath: (_h = (_g = imageConfigEntry == null ? void 0 : imageConfigEntry.custom) == null ? void 0 : _g.envConfig) == null ? void 0 : _h.imgServerPath,
    profileId: (_k = (_j = (_i = imageConfigEntry == null ? void 0 : imageConfigEntry.custom) == null ? void 0 : _i.envConfig) == null ? void 0 : _j.imageProfileId) == null ? void 0 : _k[imageProfileIdKey]
  };
};
const getParsedFeatureToggleConfig = (comingSoonFeatureToggleEntry, stockStatusFeatureToggleEntry, bopiWUpdatesSyncFeatureToggleEntry, enableFreightSavingsEntry, enablePromoBreakdownEntry, warehousePriceOnlineFeatureToggle, callProductSummaryAPI, enableBModPDPNavigationUrl, ShowMultiVariantsAvailabilityFeatureToggleEntry) => {
  var _a, _b, _c, _d, _e;
  return {
    bopiwUpdatesSync: {
      enabledApplications: (_a = bopiWUpdatesSyncFeatureToggleEntry == null ? void 0 : bopiWUpdatesSyncFeatureToggleEntry.enabled_applications) == null ? void 0 : _a.applications,
      featureOn: bopiWUpdatesSyncFeatureToggleEntry == null ? void 0 : bopiWUpdatesSyncFeatureToggleEntry.feature_on
    },
    comingSoonBanner: {
      enabledApplications: (_b = comingSoonFeatureToggleEntry == null ? void 0 : comingSoonFeatureToggleEntry.enabled_applications) == null ? void 0 : _b.applications,
      featureOn: comingSoonFeatureToggleEntry == null ? void 0 : comingSoonFeatureToggleEntry.feature_on
    },
    stockStatus: {
      enabledApplications: (_c = stockStatusFeatureToggleEntry == null ? void 0 : stockStatusFeatureToggleEntry.enabled_applications) == null ? void 0 : _c.applications,
      featureOn: stockStatusFeatureToggleEntry == null ? void 0 : stockStatusFeatureToggleEntry.feature_on
    },
    freightSavings: {
      enabledApplications: (_d = enableFreightSavingsEntry == null ? void 0 : enableFreightSavingsEntry.enabled_applications) == null ? void 0 : _d.applications,
      featureOn: enableFreightSavingsEntry == null ? void 0 : enableFreightSavingsEntry.feature_on
    },
    promoBreakdown: {
      enabledApplications: (_e = enablePromoBreakdownEntry == null ? void 0 : enablePromoBreakdownEntry.enabled_applications) == null ? void 0 : _e.applications,
      featureOn: enablePromoBreakdownEntry == null ? void 0 : enablePromoBreakdownEntry.feature_on
    },
    // New feature flag toggle pattern that takes into account the application
    warehousePriceOnline: {
      isEnabled: warehousePriceOnlineFeatureToggle == null ? void 0 : warehousePriceOnlineFeatureToggle.isEnabled,
      lastUpdated: warehousePriceOnlineFeatureToggle == null ? void 0 : warehousePriceOnlineFeatureToggle.lastUpdated
    },
    callProductSummaryAPI,
    enableBModPDPNavigationUrl,
    showMultiVariantsAvailability: ShowMultiVariantsAvailabilityFeatureToggleEntry == null ? void 0 : ShowMultiVariantsAvailabilityFeatureToggleEntry.isEnabled
  };
};
const getParsedEnabledWarehousesListConfig = (enabledWarehousesEntry, enabledWarehousesWIOEntry, enabledWarehousesBOPIWEntry, siteType) => {
  var _a, _b, _c, _d, _e, _f;
  return {
    enabledWarehousesBOPIWList: (_b = (_a = enabledWarehousesBOPIWEntry == null ? void 0 : enabledWarehousesBOPIWEntry.custom) == null ? void 0 : _a.enabledWarehousesList) == null ? void 0 : _b[siteType],
    enabledWarehousesList: (_d = (_c = enabledWarehousesEntry == null ? void 0 : enabledWarehousesEntry.custom) == null ? void 0 : _c.enabledWarehousesList) == null ? void 0 : _d[siteType],
    enabledWarehousesWIOList: (_f = (_e = enabledWarehousesWIOEntry == null ? void 0 : enabledWarehousesWIOEntry.custom) == null ? void 0 : _e.enabledWarehousesList) == null ? void 0 : _f[siteType]
  };
};
function getParsedProductDetailApiConfigParams(serviceConfig, locale) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s;
  return {
    apiUrl: serviceConfig == null ? void 0 : serviceConfig.endpoint,
    clientId: locale === "en-us" ? isBD() ? (_b = (_a = serviceConfig == null ? void 0 : serviceConfig.required_request_parameters) == null ? void 0 : _a.client_identifier) == null ? void 0 : _b.usbd : (_d = (_c = serviceConfig == null ? void 0 : serviceConfig.required_request_parameters) == null ? void 0 : _c.client_identifier) == null ? void 0 : _d.usbc : isBD() ? (_f = (_e = serviceConfig == null ? void 0 : serviceConfig.required_request_parameters) == null ? void 0 : _e.client_identifier) == null ? void 0 : _f.cabd : (_h = (_g = serviceConfig == null ? void 0 : serviceConfig.required_request_parameters) == null ? void 0 : _g.client_identifier) == null ? void 0 : _h.cabc,
    warehouseNumber: locale === "en-us" ? isBD() ? (_j = (_i = serviceConfig == null ? void 0 : serviceConfig.required_request_parameters) == null ? void 0 : _i.ware_house) == null ? void 0 : _j.usbd : (_l = (_k = serviceConfig == null ? void 0 : serviceConfig.required_request_parameters) == null ? void 0 : _k.ware_house) == null ? void 0 : _l.usbc : isBD() ? (_n = (_m = serviceConfig == null ? void 0 : serviceConfig.required_request_parameters) == null ? void 0 : _m.ware_house) == null ? void 0 : _n.cabd : (_p = (_o = serviceConfig == null ? void 0 : serviceConfig.required_request_parameters) == null ? void 0 : _o.ware_house) == null ? void 0 : _p.cabc,
    env: (_q = serviceConfig == null ? void 0 : serviceConfig.required_request_parameters) == null ? void 0 : _q.env,
    clientIdHeader: (_r = serviceConfig == null ? void 0 : serviceConfig.required_request_headers) == null ? void 0 : _r.catalog_api_client_identifier,
    maxRequestItemCount: (_s = serviceConfig == null ? void 0 : serviceConfig.custom_properties) == null ? void 0 : _s.max_item_count_per_batch_request
  };
}
const getProductDetailsServiceConfig = async () => {
  try {
    return await getConfigurationSettingByDevelopmentKey(
      ConfigContentType.ServiceConfiguration,
      `pdp_product_detail_api_service_configuration`
    );
  } catch (err) {
    console.error(
      "PDP product detail API service configuration - content stack fetch failed",
      err
    );
    return null;
  }
};
const getProductDetailsV2ServiceConfig = async () => {
  try {
    return await getConfigurationSettingByDevelopmentKey(
      ConfigContentType.ServiceConfiguration,
      `pdp_product_detail_api_service_configuration_v2`
    );
  } catch (err) {
    console.error(
      "PDP product detail API service configuration V2 - content stack fetch failed",
      err
    );
    return null;
  }
};
export {
  getBModPDPNavigationUrlFeatureToggleConfig,
  getBOPIUpdatesSyncFeatureToggle,
  getComingSoonFeatureToggleConfig,
  getEnabledWarehousesBOPIWConfig,
  getEnabledWarehousesConfig,
  getEnabledWarehousesWIOConfig,
  getFreightSavingsFeatureToggle,
  getImageConfig,
  getInventoryApiConfig,
  getParsedEnabledWarehousesListConfig,
  getParsedFeatureToggleConfig,
  getParsedImageConfig,
  getParsedInventoryApiConfig,
  getParsedLucidWorksApiConfig,
  getParsedPillBadgeConfig,
  getParsedProductApiConfig,
  getParsedProductDetailApiConfigParams,
  getPillBadgeConfig,
  getProductApiConfig,
  getProductDetailsServiceConfig,
  getProductDetailsV2ServiceConfig,
  getProductSummaryAPIFeatureToggle,
  getPromoBreakdownFeatureToggle,
  getSearchConfig,
  getShowMultiVariantsAvailabilityFeatureToggle,
  getStockStatusFeatureToggleConfig,
  getTranslations,
  getTranslationsConfig,
  getWarehousePriceOnlineFeatureToggleConfig
};
